// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__IWeIL","cross":"Popup_cross__jWbek","swing-in":"Popup_swing-in__JqqEW"};